var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.3125,
    stroke: "#178F4F",
    strokeWidth: 1.375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9335 13.6516V8.92228C7.9335 8.66441 8.00528 8.46503 8.14883 8.32414C8.29505 8.18324 8.49576 8.11279 8.75097 8.11279H13.4643C13.7222 8.11279 13.9229 8.18324 14.0665 8.32414C14.21 8.46503 14.2818 8.66441 14.2818 8.92228V13.6516C14.2818 13.9068 14.21 14.1049 14.0665 14.2458C13.9229 14.3893 13.7222 14.4611 13.4643 14.4611H8.75097C8.49576 14.4611 8.29505 14.3893 8.14883 14.2458C8.00528 14.1049 7.9335 13.9068 7.9335 13.6516Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStep);
export default __webpack_public_path__ + "static/media/active_step.fba47105.svg";
export { ForwardRef as ReactComponent };